import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
const api = process.env.REACT_APP_API_ADDRESS;

export const tagsApi = createApi({
    reducerPath: 'tagsApi',
    tagTypes: ['Tags'],
    baseQuery: fetchBaseQuery({
        baseUrl: api,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");
            if(token) headers.set("token", token);
            return headers;
        }
    }),

    endpoints: (builder) => ({

        createTag: builder.mutation({
            query: (body) => ({
                url: `/api/tags/create`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Tags"]
        }),

        updateTag: builder.mutation({
            query: (body) => ({
                url: `/api/tags/update`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Tags"]
        }),

        deleteTag: builder.mutation({
            query: (body) => ({
                url: `/api/tags/delete`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Tags"]
        }),

        getTags: builder.query({
            query: (params) => ({
                url: `/api/tags/get`,
                method: "GET",
                params
            }),
            providesTags: ["Tags"]
        })

    }),
  })

export const {
    useCreateTagMutation,
    useUpdateTagMutation,
    useDeleteTagMutation,
    useGetTagsQuery
} = tagsApi;